<div class="w-100 d-flex flex-row align-items-center justify-content-end" *ngIf="isExtraSmall$ | async">
<button mat-icon-button (click)="openRecorder()"><mat-icon>mic</mat-icon></button>
</div>
